<template lang="pug">
    .order-admin-reorder
        v-tooltip(bottom)
            template(v-slot:activator="{ on }")
                v-btn(
                    v-bind="$attrs"
                    v-on="on"
                    @click="dialog = true" text)
                    slot
                        span.text-subtitle-2 {{ $t('labels.reorder') }}
                        v-icon(dense) replay
            span(v-if="tooltip") {{ tooltip }}
        modal-dialog.admin-reorder-modal(
            v-model="dialog"
            :show-overlay="loading"
            :title="$t('labels.reorder_modal_title', { 'identifier': orderIdentifier })"
            :ok-text="$t('actions.reorder')"
            :ok-disabled="!formIsValid"
            @cancel="dialog = false"
            @ok="reorder"
            cancel-button)
            text-input(
                v-model="reason"
                v-validate.immediate="'required'"
                label="labels.reorder_reason"
                name="reorder_reason"
                :error-messages="errors.collect('reorder_reason')"
                :data-vv-as="$t('labels.reorder_reason')"
            )
            entity-select-input(
                v-if="isCloudCanteenMasterOrder && companyIri"
                v-model="onBehalfOfUserId"
                v-validate.immediate="'required'"
                use-id-field
                name="reorder_user"
                label="labels.reorder_by_user"
                :entity="selectApiClientType.USER"
                :error-messages="errors.collect('reorder_user')"
                :query-params="{ company: companyIri}"
                autocomplete
                :data-vv-as="$t('labels.employee')")

</template>

<script>
import RestApiCollection from '@/api/RestApiCollection'
import ApiClientType from '@/api/RestApiType'
import routeType from '@/router/routeType'
import ModalDialog from '@/components/dialog/ModalDialog'
import TextInput from '@/components/form/Inputs/TextInput'
import SelectInput from '@/components/form/Inputs/SelectInput.vue'
import EntitySelectInput from '@/components/form/Inputs/EntitySelectInput.vue'
import SelectApiClientType from '@/api/SelectApiClientType'

export default {
    components: {
        EntitySelectInput,
        SelectInput,
        ModalDialog,
        TextInput,
    },
    props: {
        order: {
            type: Object,
            default: null,
        },
        tooltip: {
            type: String,
            default: null,
        },
    },
    inject: {
        $validator: 'formValidator',
    },
    data() {
        return {
            selectApiClientType: SelectApiClientType,
            companyApiClient: RestApiCollection.get(ApiClientType.COMPANIES),
            dialog: false,
            loading: false,
            reason: '',
            onBehalfOfUserId: null,
        }
    },
    computed: {
        orderId() {
            return this.order?.id
        },
        orderIdentifier() {
            return this.order?.identifier
        },
        isCloudCanteenMasterOrder() {
            return this.order?.cloudcanteen && !this.order?.userProfile
        },
        companyIri() {
            return this.order?.company
        },
        formIsValid() {
            if (this.isCloudCanteenMasterOrder) {
                return this.reason && this.onBehalfOfUserId
            }

            return this.reason
        },
    },
    methods: {
        reorder() {
            this.loading = true
            RestApiCollection.get(ApiClientType.ORDERS)
                .reOrder(this.orderId, this.reason, this.onBehalfOfUserId)
                .then((response) => {
                    const id = response['@id'].split('/').pop()
                    this.dialog = false
                    this.$router.push({
                        name: routeType.ORDER_EDIT,
                        params: { id },
                    })
                })
                .finally(() => {
                    this.reason = ''
                    this.loading = false
                })
        },
    },
}
</script>
